import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { NewConversationForm } from './NewConversationForm';

interface NewConversationDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated: (conversationId: string, mode: 'pre_call' | 'post_call') => void;
}

export function NewConversationDialog({ open, onClose, onCreated }: NewConversationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>New Conversation</DialogTitle>
      <DialogContent>
        <NewConversationForm onCreated={onCreated} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
}
